import { create } from 'zustand';
import { NoiseReductionStore } from './types';

const defaultPagination = { pageIndex: 0, pageSize: 8, sortBy: [] };
const useNoiseReductionTabContext = create<NoiseReductionStore>((set, get) => ({
  aptaTablepaginationInfo: {
    ...defaultPagination,
    sortBy: [{ id: 'aptaSuccessCount', desc: true }],
  },
  noiseReductionTablepaginationInfo: {
    ...defaultPagination,
    sortBy: [{ id: 'reductionPercentage', desc: true }],
  },
  noiseReductionTeamTablepaginationInfo: {
    ...defaultPagination,
    sortBy: [{ id: 'reductionPercentage', desc: true }],
  },
  setAPTAPagination: params => {
    const state = get();
    set({
      ...state,
      aptaTablepaginationInfo: {
        ...state.aptaTablepaginationInfo,
        ...params,
      },
    });
  },
  setNoiseReductionPagination: params => {
    const state = get();
    set({
      ...state,
      noiseReductionTablepaginationInfo: {
        ...state.noiseReductionTablepaginationInfo,
        ...params,
      },
    });
  },
  setSelectedAPTAData: selectedAPTAData => {
    const state = get();
    set({ ...state, selectedAPTAData });
  },
  setSelectedNoiseReductionData: selectedNoiseReductionData => {
    const state = get();
    set({ ...state, selectedNoiseReductionData });
  },
  setNoiseReductionTeamPagination: params => {
    const state = get();
    set({
      ...state,
      noiseReductionTeamTablepaginationInfo: {
        ...state.noiseReductionTeamTablepaginationInfo,
        ...params,
      },
    });
  },
  setSelectedNoiseReductionTeamData: selectedNoiseReductionTeamData => {
    const state = get();
    set({ ...state, selectedNoiseReductionTeamData });
  },

  resetAPTAPagination: () => {
    const state = get();
    set({ ...state, aptaTablepaginationInfo: defaultPagination });
  },
  resetNoiseReductionPagination: () => {
    const state = get();
    set({ ...state, noiseReductionTablepaginationInfo: defaultPagination });
  },
  resetNoiseReductionTeamPagination: () => {
    const state = get();
    set({ ...state, noiseReductionTeamTablepaginationInfo: defaultPagination });
  },

  resetAllPagination: () => {
    const state = get();
    set({
      ...state,
      aptaTablepaginationInfo: {
        ...defaultPagination,
        sortBy: [{ id: 'aptaSuccessCount', desc: true }],
      },
      noiseReductionTablepaginationInfo: {
        ...defaultPagination,
        sortBy: [{ id: 'reductionPercentage', desc: true }],
      },
      noiseReductionTeamTablepaginationInfo: {
        ...defaultPagination,
        sortBy: [{ id: 'reductionPercentage', desc: true }],
      },
    });
  },
}));
export { useNoiseReductionTabContext };
